const FileTypeActions = require("../actions/FileTypeActions.js");
const MetadataSpecs = require("../MetadataSpecs.js");

const FileTypeReducers = {
    [FileTypeActions.Get](prev, action) {
        let update = {
            AreLoading: true,
            Data: null,
            LoadError: null
        };

        return Object.assign({}, prev, {
            FileTypes: update
        });
    },
    [FileTypeActions.Got](prev, action) {
        let update = {
            AreLoading: false,
            Data: action.Data,
            LoadError: null
        };

        return Object.assign({}, prev, {
            FileTypes: update,
            // Useful for testing:
            //SelectedFileType: action.Data[0],
            //Metadata: {
            //    CurrentSpec: MetadataSpecs[action.Data[0].ClassName]
            //}
        });
    },
    [FileTypeActions.GetErrored](prev, action) {
        let update = {
            AreLoading: false,
            Data: null,
            LoadError: action.Error
        };

        return Object.assign({}, prev, {
            FileTypes: update
        });
    },
    [FileTypeActions.Select](prev, action) {
        const typeName = action.FileType.ClassName;

        return Object.assign({}, prev, {
            SelectedFileType: action.FileType,
            Metadata: {
                CurrentSpec: MetadataSpecs[typeName]
            }
        });
    },
    [FileTypeActions.DeSelect](prev, action) {
        return Object.assign({}, prev, {
            SelectedFileType: null
        });
    }
};

module.exports = FileTypeReducers;


// WEBPACK FOOTER //
// ./src/reducers/FileTypeReducers.js